export default "/static/build/bg.webp";